/* AUTAVEX — накидки: фото типів пошиву за матеріалом
   0 — Алькантара, 1 — Екошкіра */
window.AV_NK_SEWPIC={
 0:{std:'6DC6BF23-28E5-4B1D-A8DC-11779456FF42.jpg?v=1786523015',
    prm:'FD4F891C-1AA5-40BE-A0C1-B429097560A6.jpg?v=1786523016',
    prp:'7BCD3A37-A632-4CE2-A842-39B8AD0FB8BD.jpg?v=1786523016'},
 1:{std:'IMG-3984.jpg?v=1786526350',
    prm:'IMG-3983.jpg?v=1786526350',
    prp:'IMG-3985.jpg?v=1786526350'}
};
